import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { underwritingService } from "@/services/underwriting";

export function useAssessmentByBorrowerQuery(borrowerId: number | null) {
  return useQuery({
    queryKey: queryKeys.assessmentByBorrower(borrowerId),
    queryFn: () => {
      if (borrowerId == null) return Promise.reject(new Error("No borrower ID"));
      return underwritingService.getAssessmentByBorrowerId(borrowerId);
    },
    enabled: borrowerId != null,
  });
}
